module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAADCAYAAACEeL/nAAAAF0lEQVR4XmNgGCjw//9/h//0B/sHzGIA3t/tEyFWyvAAAAAASUVORK5CYII="